module.exports = __webpack_public_path__ + "static/media/1-Transparente.1c472b95.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/1-Transparente.png
// module id = 1485
// module chunks = 0